import styled from 'styled-components';

import { Card, Button, Text } from '@gympass/yoga';

import Link from 'components/Link';

export const ProgramContainer = styled.div`
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content;
  justify-items: center;
  min-height: 100vh;
  padding: 0;
`;

export const ProgramHeader = styled.div`
  background: linear-gradient(
    76.4deg,
    ${({ theme }) => theme.yoga.colors.primary}
      ${({ theme }) => theme.yoga.spacing.zero}%,
    ${({ theme }) => theme.yoga.colors.primaryLight}
      ${({ theme }) => theme.yoga.borders.contentWidth}
  );
  display: grid;
  grid-template-columns: ${({ theme }) => `minmax(100%,
    ${theme.yoga.sizes.maxContentWidth}px)`};
  justify-items: center;
  min-height: ${({ theme }) => theme.yoga.sizes.programHeader}px;
  width: 100%;
`;

export const ProgramHeaderContent = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  padding: ${({ theme }) => theme.yoga.spacing.xxlarge}px
    ${({ theme }) => theme.yoga.spacing.small}px
    ${({ theme }) => theme.yoga.spacing.small}px;
  max-width: ${({ theme }) => theme.yoga.sizes.maxContentWidth}px;
  width: 100%;
`;

export const BackButton = styled(Text.Small)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
`;

export const BackLink = styled(Link)`
  align-items: center;
  color: ${({ theme }) => theme.yoga.colors.white};
  display: grid;
  grid-template-columns: auto 1fr;

  &:hover {
    text-decoration: none;
  }
`;

export const ProgramName = styled(Text.H3)`
  color: ${({ theme }) => theme.yoga.colors.inputBackground};
`;

export const ProgramDescription = styled(Text.H5)`
  color: ${({ theme }) => theme.yoga.colors.inputBackground};
`;

export const ModulesCount = styled(Text)`
  color: ${({ theme }) => theme.yoga.colors.inputBackground};
`;

export const PinIconsContainer = styled.div`
  position: absolute;
  right: 0;
  margin: 0 auto;
  top: 0;
  overflow: hidden;
`;

export const PinIcon = styled.div`
  margin: 0 ${({ theme }) => theme.yoga.spacing.xxxlarge}px;

  &:last-of-type {
    position: absolute;
    top: -${({ theme }) => theme.yoga.spacing.xxxlarge}px;
    right: -${({ theme }) => theme.yoga.spacing.xxxlarge}px;
  }

  svg {
    height: ${({ theme }) => theme.yoga.sizes.smallPinSize.height}px;
    opacity: 0.3;
    width: ${({ theme }) => theme.yoga.sizes.smallPinSize.width}px;
  }
`;

export const ActivitiesContent = styled(Card.Content)`
  display: grid;
  gap: ${({ theme }) => theme.yoga.spacing.small}px;
  grid-auto-rows: max-content;
  max-width: ${({ theme }) => theme.yoga.sizes.maxContentWidth}px;
  padding: ${({ theme }) => theme.yoga.spacing.xxlarge}px
    ${({ theme }) => theme.yoga.spacing.small}px;
  width: 100%;
`;

export const ActivitiesTopics = styled.div`
  background-color: ${({ theme }) => theme.yoga.colors.white};
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  box-shadow: ${({ theme }) => theme.yoga.elevations.medium};
  display: grid;
  grid-template-columns: 1fr auto;
  padding: ${({ theme }) => theme.yoga.spacing.small}px
    ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const TopicsTitle = styled(Text)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
`;

export const PagesCount = styled(Text.Small)`
  color: ${({ theme }) => theme.yoga.colors.textSecondary};
`;

export const TopicsButton = styled(Button.Link)`
  svg {
    fill: ${({ theme }) => theme.yoga.colors.primary};
    margin-left: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
    height: ${({ theme }) => theme.yoga.spacing.large}px;
    width: ${({ theme }) => theme.yoga.spacing.large}px;
  }
`;

export const Dropdown = styled.div<{
  isCollapsed: boolean;
}>`
  border-top: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme }) => theme.yoga.colors.tableBorder};
  display: ${({ isCollapsed }) => (isCollapsed ? 'grid' : 'none')};
  gap: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  margin-top: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  padding-top: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const TopicItem = styled(Link)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;
`;
